export default "__VITE_ASSET__BVDox5gg__"